// Âm thanh tạo bằng Web Audio, không tải file ngoài. OBS cho tự phát âm thanh trong nguồn trình duyệt.

let ctx: AudioContext | null = null;
const audio = () => {
  if (!ctx) {
    const Ctor =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext: typeof AudioContext })
        .webkitAudioContext;
    ctx = Ctor ? new Ctor() : null;
  }
  return ctx;
};

const noiseBurst = (seconds: number, volume: number, lowpassHz: number) => {
  const a = audio();
  if (!a) return;
  const buffer = a.createBuffer(
    1,
    Math.floor(a.sampleRate * seconds),
    a.sampleRate
  );
  const data = buffer.getChannelData(0);
  for (let i = 0; i < data.length; i++)
    data[i] = (Math.random() * 2 - 1) * (1 - i / data.length) ** 2;
  const src = a.createBufferSource();
  src.buffer = buffer;
  const filter = a.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.value = lowpassHz;
  const gain = a.createGain();
  gain.gain.value = volume;
  src.connect(filter).connect(gain).connect(a.destination);
  src.start();
};

export const playBoom = () => noiseBurst(1.2, 0.9, 600);
export const playPop = () => noiseBurst(0.25, 0.5, 2500);

export const playScream = () => {
  const a = audio();
  if (!a) return;
  const osc = a.createOscillator();
  osc.type = 'sawtooth';
  const gain = a.createGain();
  const t = a.currentTime;
  osc.frequency.setValueAtTime(500, t);
  osc.frequency.exponentialRampToValueAtTime(1400, t + 0.3);
  osc.frequency.exponentialRampToValueAtTime(700, t + 1.2);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(0.6, t + 0.05);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + 1.3);
  osc.connect(gain).connect(a.destination);
  osc.start(t);
  osc.stop(t + 1.35);
  noiseBurst(1.0, 0.3, 4000);
};
